import { render, staticRenderFns } from "./coreData.vue?vue&type=template&id=031826d9"
import script from "./coreData.vue?vue&type=script&lang=js"
export * from "./coreData.vue?vue&type=script&lang=js"
import style0 from "./coreData.vue?vue&type=style&index=0&id=031826d9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports